/**
 * The reference year for the farm age factors (home_age / roof_age): the year of the TERM's
 * effective date, NOT the wall-clock rating date. A dwelling should rate at its age as-of the policy
 * effective date, so a backdated or imported term (e.g. a Guidewire import effective last year, rated
 * today) is not aged an extra year. Falls back to rateControlDate, then the current year. #34115
 *
 * Lives here (not in the rater) so the dec mapper derives a dwelling's age from the same year the
 * CFM farm rater sent ClarionDoor (#37128).
 */
export function getTermEffectiveYear(policyDetail: {
  effectiveDate?: string | null;
  rateControlDate?: string | null;
  global?: { farmEffectiveDate?: string | null; homeEffectiveDate?: string | null } | null;
}): number {
  const src =
    policyDetail?.global?.farmEffectiveDate ||
    policyDetail?.effectiveDate ||
    policyDetail?.global?.homeEffectiveDate ||
    policyDetail?.rateControlDate;
  const year = src ? Number(String(src).slice(0, 4)) : Number.NaN;
  return Number.isFinite(year) && year > 1900 ? year : new Date().getFullYear();
}
